import { SellingEligibilityDenialReasonDTO } from '@core/dto/selling-eligibility.dto';

const ELIGIBILITY_DETAIL_TO_I18N: Partial<Record<SellingEligibilityDenialReasonDTO, string>> = {
  SELLING_ALLOWLIST_EMPTY: 'INTL_CLIENT_ELIGIBILITY_SELLING_ALLOWLIST_EMPTY',
  ADDRESS_COUNTRY_MISSING: 'INTL_CLIENT_ELIGIBILITY_ADDRESS_COUNTRY_MISSING',
  ADDRESS_COUNTRY_NOT_ALLOWED: 'INTL_CLIENT_ELIGIBILITY_ADDRESS_COUNTRY_NOT_ALLOWED',
};

/** Machine codes returned in API `detail` for selling-region eligibility (banner copy, not snackbar). */
export function isSellingEligibilityApiDetail(detail: string | null | undefined): boolean {
  if (detail == null || String(detail).trim() === '') {
    return false;
  }
  const trimmed = String(detail).trim();
  return trimmed in ELIGIBILITY_DETAIL_TO_I18N;
}

/**
 * Maps API `detail` machine codes to the same ngx-translate keys as the client eligibility banner.
 * Unknown strings are returned unchanged (legacy human-readable messages).
 */
export function i18nKeyFromApiErrorDetail(detail: string | null | undefined): string {
  if (detail == null || String(detail).trim() === '') {
    return 'INTL_AN_ERROR_HAS_OCCURED';
  }
  const trimmed = String(detail).trim();
  return ELIGIBILITY_DETAIL_TO_I18N[trimmed as SellingEligibilityDenialReasonDTO] ?? trimmed;
}
